module.exports = __webpack_public_path__ + "static/media/connect-wallet-slide-1.33133f25.svg";